import { Modal as ModalChakra, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from '@chakra-ui/react'
import { Visible } from 'components/Visible';
import { Button } from 'components/Button';
import { ReactNode } from 'react';

type ModalProps = {
    title: string;
    label: string;
    buttonLabel: string;
    children: ReactNode;
    iconButton?: React.ReactElement;
    buttonIcon?: React.ReactElement;
}

const Modal = ({title, label, buttonLabel, iconButton, buttonIcon, children}: ModalProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure()
    
    return (
          <>
            <Button icon={iconButton} label={label} onClick={onOpen} colorScheme="blue" />
            <ModalChakra variant='#00000' size='3xl' isOpen={isOpen} onClose={onClose}>
              <ModalOverlay />
              <ModalContent borderRadius="50px">
                <ModalHeader>{title}</ModalHeader>
                <ModalCloseButton color='grey' padding={8} />
                <ModalBody padding={50}>
                 {children}
                </ModalBody>
                <Visible when={!!buttonLabel}>
                <ModalFooter>
                  <Button label={buttonLabel} colorScheme='blue' icon={buttonIcon} onClick={onClose} />
                </ModalFooter>
                </Visible>
              </ModalContent>
            </ModalChakra>
          </>
    );
}

export {Modal};